import Bugsnag from '@bugsnag/js';

const initiate = () => {
    if (process?.env?.BUGSNAG_API_KEY == null) {
        return;
    }

    Bugsnag.start({
        apiKey: process.env.BUGSNAG_API_KEY,
        appVersion: process?.env?.BUGSNAG_APP_VERSION ?? '',
        releaseStage: process?.env?.BUGSNAG_STAGE ?? '',
    });
};

initiate();

export const log = ({ error }) => Bugsnag.notify(error);
